const INTERACTIVE_PROJECT_CONSTANT = 'LI/PROJECT/TEMP_PROJECT';

export default INTERACTIVE_PROJECT_CONSTANT;
